import { Grid } from '@material-ui/core';
import { FormikActions, getIn } from 'formik';
import * as _ from 'lodash';
import { inject } from 'mobx-react';
import * as React from 'react';
import ESDialog from 'src/common/ESDialog';
import FullWidthField from 'src/common/FullWidthField';
import SelectField from 'src/common/SelectField/SelectField';
import { IRegion, IUser } from 'src/Definitions';
import { IdentifierEntityDto } from 'src/generated_client';
import { IStores } from 'src/Stores';
import * as Yup from 'yup';

interface IRegionFormValues {
    name: string;
    championIds: string[];
}

const RegionSchema = Yup.object().shape({
    championIds: Yup.string().required('At least one Champion is required'),
    name: Yup.string().required('Name is Required'),
    region: Yup.object().shape({}),
});

interface IRegionDialogProps {
    close?: () => void;
    getUsers?: (pageNumber?: number, roleName?: string) => Promise<void>;
    isLoading?: boolean;
    isOpen?: boolean;
    region?: IRegion;
    saveRegion?: (region: IRegion) => Promise<void>;
    users?: IUser[];
    champions?: IdentifierEntityDto[];
}

class RegionDialog extends React.Component<IRegionDialogProps> {
    public save = (values: IRegionFormValues, formikBag: FormikActions<IRegionFormValues>) => {
        const regionToSave = { ...this.props.region } as IRegion;
        regionToSave.name = values.name;
        regionToSave.champions = [];
        values.championIds.forEach((championId) => {
            const user = _.find(this.props.users, { id: championId });
            if (user) {
                regionToSave.champions.push(
                    new IdentifierEntityDto({ name: user.name, id: user.id })
                );
            }
        });
        this.props.saveRegion!(regionToSave).finally(() => formikBag.setSubmitting(false));
    };

    public componentDidMount() {
        this.props.getUsers!(undefined, 'Champion');
    }

    public getUserName(user: IUser) {
        if (user && user.name) {
            return user.name;
        }
        return '';
    }

    public getUserValue(user: IUser) {
        if (user && user.id) {
            return user.id;
        }
        return '';
    }

    public getChampionIds() {
        if (this.props.region && this.props.region.champions) {
            return this.props.region.champions.map((x) => x.id) as string[];
        } else {
            return [];
        }
    }

    public render() {
        const { close, isLoading, isOpen, region, users } = this.props;
        const initialValues = { name: region!.name, championIds: this.getChampionIds() };

        const hasValue = (field: string, values: IRegionFormValues) => {
            const value = getIn(values, field);

            return !!value;
        };

        return (
            <ESDialog
                close={close!}
                initialValues={initialValues}
                isLoading={isLoading}
                open={isOpen!}
                save={this.save}
                title={region!.isNew ? 'Create Region' : 'Edit Region'}
                validationSchema={RegionSchema}
            >
                {({ values }) => (
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <FullWidthField
                                autoFocus
                                id="region-name"
                                name="name"
                                label="Name"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <SelectField
                                data-cy="championIds"
                                inputId="championIds"
                                getName={this.getUserName}
                                getValue={this.getUserValue}
                                items={users}
                                label="Champions"
                                name="championIds"
                                checkedItems={values.championIds}
                                multiple
                                fullWidth
                                required
                                shrinkLabel={hasValue('championIds', values)}
                            />
                        </Grid>
                    </Grid>
                )}
            </ESDialog>
        );
    }
}

const InjectedRegionDialog = inject<IStores, IRegionDialogProps, Partial<IRegionDialogProps>, any>(
    (stores: IStores) => ({
        close: stores.regions.closeDialog,
        getUsers: stores.users.getAllUsers,
        isLoading: stores.regions.isLoading,
        isOpen: stores.regions.isModalOpen,
        region: stores.regions.selectedRegion,
        saveRegion: stores.regions.saveRegion,
        users: stores.users.users,
    })
)(RegionDialog);

export default InjectedRegionDialog;



// WEBPACK FOOTER //
// ./src/regions/RegionDialog.tsx